import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitLayoutsSidePanel.module.scss';

const SidePanel = ({ className = '', component, testId = '' }) => (
  <section
    className={classnames(styles.element, className)}
    data-testid={testId}
  >
    {component}
  </section>
);

SidePanel.propTypes = {
  className: PropTypes.string,
  component: PropTypes.shape({}).isRequired,
  testId: PropTypes.string,
};

export default SidePanel;
